// extracted by mini-css-extract-plugin
export default {"ForumSearch__headline":"qr_a big_sn big_va","ForumSearch__img":"qr_b","ForumSearch__searchAdsAndShoppingAds":"qr_c","ForumSearch__results--empty":"qr_e"};